/*
 * @Author: limeng
 * @Date: 2025-12-05 14:49:06
 * @FilePath: /wallet-h5/src/utils/myBMap.js
 * @Description:
 */
import AMapLoader from "@amap/amap-jsapi-loader";
import { getCityLocation } from "../api/common";

export default {
  getLocations: function (callback, errorCallback) {
    const geoInstance = new window.LBS.WebComponent.Geolocation({
      key: "CQVBZ-VZ2KT-OBIXK-VQCNZ-TS3M2-7YBCC",
      referer: "h5",
    });
    geoInstance.getIpLocation(
      (res) => callback({ ...res, gpsDetail: "定位成功" }, res.lat, res.lng),
      (err) => getCityLocationFn(callback, errorCallback)
    );

    // window._AMapSecurityConfig = {
    //   securityJsCode: "6a2c350a04ce37ccf6e558d859049c7a",
    // };
    // AMapLoader.load({
    //   key: "eb0ee74bdd6fcd3f370e6621dfaeead5",
    //   version: "2.0",
    //   plugins: ["AMap.Geolocation", "AMap.Geocoder"],
    // }).then((AMap) => {
    //   AMap.plugin("AMap.Geolocation", function () {
    //     new AMap.Geolocation().getCurrentPosition(function (status, result) {
    //       if (status == "complete") {
    //         const { lng, lat } = result.position;
    //         AMap.plugin("AMap.Geocoder", function () {
    //           new AMap.Geocoder().getAddress(
    //             [lng, lat],
    //             function (status, res) {
    //               if (status === "complete" && res.info === "OK") {
    //                 let address = res.regeocode.addressComponent;
    //                 callback(
    //                   {
    //                     province: address.province,
    //                     city: address.city || address.province,
    //                     gpsDetail: "定位成功",
    //                   },
    //                   lat,
    //                   lng
    //                 );
    //               } else {
    //                 getCityLocationFn(callback, errorCallback);
    //               }
    //             }
    //           );
    //         });
    //       } else {
    //         getCityLocationFn(callback, errorCallback);
    //       }
    //     });
    //   });
    // });
  },
};

const getCityLocationFn = (callback, errorCallback) => {
  getCityLocation()
    .then(({ code, data }) => {
      if (code === 200 && data?.cityId) {
        callback(
          {
            province: data.provinceName,
            city: data.cityName,
            gpsDetail: "定位成功",
          },
          "",
          ""
        );
      } else {
        errorCallback("定位失败，请手动选择城市");
      }
    })
    .catch((err) => {
      errorCallback("定位失败，请手动选择城市");
    });
};
